import { FlatDomainDataContext, IDomainData, IDomainMetadata, IUIComponentDef, IUICompositeComponentDef } from "../datatypes";

//get second last, or if there is only one return that
let id = 0;


/**
 * 
 * @param qname e.g "PaymentHeader.Id"
 */
export function splitAttrQName(qname:string) {
    let objectName: string|undefined;
    let attrName: string|undefined;

    if(!qname){
        return {objectName, attrName} 
    }
    let parts = qname.split('.');
    if(parts.length != 2){
        console.error(`invalid qualified atribute name ${qname}`);
    }
    return {objectName: parts[0], attrName:parts[1]};
}
/**
 * get parent or self single binding name.
 * 
 * @param binding '.' delimited domain object binding string.
 */
export function getParentFromBinding(binding:string) {
  let objNames = binding.split('.');
  let parentName = objNames[Math.max(objNames.length-2,0)];
  return parentName ? parentName.trim() : null;
}
// if there's more than one, return the last
export function getAttributeNameFromBinding(binding:string) {
  let objNames = binding.split('.');
  let attributeName = objNames.length > 1 ? objNames[objNames.length-1] : null;
  return attributeName ? attributeName.trim() : null;
}

/**
 * flatten domainData tree node to edgeName-domainData pair recursively. 
 * Stop flattern further if domainData is array - Arrays would be populated into the context when listBinding is used
 * 
 * @param metadata metadata of domain data argument.
 * @param domainData domain data to be flattern
 * @param domainDataCtx initial empty domain data context 
 */
export function createContext(metadata:IDomainMetadata, domainData:IDomainData|IDomainData[], 
                              domainDataCtx?:FlatDomainDataContext) {
  if(!domainDataCtx) domainDataCtx = {};
  if(!domainData) domainData = {};

  let edgeName:string = metadata.referenceName || metadata.objectName;

  domainDataCtx[edgeName] = {data: domainData, metaData: metadata};

  if(Array.isArray(domainData)) {
    //Arrays would be populated into the context when listBinding is used
    return domainDataCtx; 
  }

  //**NOTE**: For null values, we assign empty object to pass down by reference
  // so that later on if it gets assigned values we update parent tree too

  //Add reference attributes to the context so that, they can be accessed as referencedObjectName.attribute
  if(metadata.referenceAttributes) {
    for(let objectName in metadata.referenceAttributes) {
      let refMetadata = metadata.referenceAttributes[objectName].referenceMetadata;
      if(!domainData[refMetadata.referenceName]) {
        // domainData[refMetadata.referenceName] = {}; // why modify original domain data???
        domainDataCtx[refMetadata.referenceName] = {data: {}, metaData: refMetadata}
      }else{
        createContext(refMetadata, domainData[refMetadata.referenceName] as IDomainData, domainDataCtx);
      }
    }
  }

  if(metadata.children) {
    for(let childMetadata of metadata.children) {
      if(!domainData[childMetadata.objectName]) {
        if(childMetadata.maxCardinality === 1) {
          //   domainData[childMetadata.objectName] = {}; // avoid modifying input argument!
          domainDataCtx[childMetadata.objectName] = {data:{}, metaData: childMetadata}
        } else {
          //   domainData[childMetadata.objectName] = []; // avoid modifying input argument!
          domainDataCtx[childMetadata.objectName] = {data:[], metaData: childMetadata}
        }
      }else{
        createContext(childMetadata, domainData[childMetadata.objectName] as IDomainData, domainDataCtx);
      }
    }
  }

  //metadata.attributes is not suppose to be added to the context as they should be available as objectName.attributeName

  return domainDataCtx;
}


export function setMissingComponentId(metadata:IUIComponentDef, parentComponentId?:string, myIdx?:number){
    if(!metadata.componentId){
        if(!myIdx != null){ // myIdx !== null && myIdx !== undefined
            metadata.componentId=`${metadata.type}_${myIdx}_${parentComponentId}`;
        }else{
            metadata.componentId=`${metadata.type}_0`;
        }
    }
    ((metadata as IUICompositeComponentDef).children||[]).forEach((c, idx)=>{
        setMissingComponentId(c, metadata.componentId, idx);
    })
}